import { BackButton } from '@/components/Custom/Button/BackButton';
import { TFunction } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { DownloadIconV3 } from '@/components/SvgIcons/DownloadIconV3';
import { PdfDownloadButton } from '@/components/Custom/Button/PdfButton/PdfDownloadButton/PdfDownloadButton';

interface PreviewPdfLayoutProps {
  t: TFunction<undefined>;
  children: React.ReactNode;
  filename: string;
  footerCopyrightText?: string;
  pdfModel: React.ReactNode;
}

export const PreviewPdfLayout = ({
  t,
  children,
  filename,
  footerCopyrightText,
  pdfModel,
}: PreviewPdfLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-200 px-8 pt-10 pb-20">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <BackButton
              buttonClassName="w-7 min-w-7 h-7 min-h-7 shadow-lg"
              arrowClassName="text-2sm"
              onClick={() => navigate(-1)}
            />
            <div className="text-lg">{t('common:pdfPreview')}</div>
          </div>
          <PdfDownloadButton
            text="Télécharger"
            filename={filename}
            footerCopyrightText={footerCopyrightText}
            pdfModel={pdfModel}
            buttonClassName="bg-primary"
            textClassName="text-white font-normal text-sm"
            leftIcon={
              <DownloadIconV3 className="w-5 h-5 [&>path]:fill-white" />
            }
          />
        </div>
        <div className="bg-white p-8 rounded-lg shadow-lg">{children}</div>
      </div>
    </div>
  );
};
